var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(-1950 209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M-11.143,0a.854.854,0,0,1-.606-.251.857.857,0,0,1,0-1.212L-1.463-11.749a.857.857,0,0,1,1.212,0,.857.857,0,0,1,0,1.212L-10.537-.251A.854.854,0,0,1-11.143,0Z",
    transform: "translate(1968 -187)",
    fill: "#e05f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M-.857,0a.854.854,0,0,1-.606-.251L-11.749-10.537a.857.857,0,0,1,0-1.212.857.857,0,0,1,1.212,0L-.251-1.463a.857.857,0,0,1,0,1.212A.854.854,0,0,1-.857,0Z",
    transform: "translate(1968 -187)",
    fill: "#e05f5f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    d: "M16,1.5A14.5,14.5,0,0,0,5.747,26.253,14.5,14.5,0,0,0,26.253,5.747,14.405,14.405,0,0,0,16,1.5M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(1950 -209)",
    fill: "#e05f5f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationErrorIcon);
export default __webpack_public_path__ + "static/media/notification-error-icon.6e9513a161fa53db9899acba1ec5b882.svg";
export { ForwardRef as ReactComponent };